import { CorrespondenceTeamDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCorrespondenceTeam = createAction(
  '[CorrespondenceTeam] Load CorrespondenceTeam'
);

export const loadCorrespondenceTeamSuccess = createAction(
  '[CorrespondenceTeam] Load CorrespondenceTeam Success',
  props<{ correspondenceTeam: CorrespondenceTeamDto[] }>()
);

export const loadCorrespondenceTeamFailure = createAction(
  '[CorrespondenceTeam] Load CorrespondenceTeam Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCorrespondenceTeam = createAction(
  '[CorrespondenceTeam] Add CorrespondenceTeam',
  props<{ newCorrespondenceTeam: CorrespondenceTeamDto[] }>()
);

export const addCorrespondenceTeamSuccess = createAction(
  '[CorrespondenceTeam] Add CorrespondenceTeam Success',
  props<{ newCorrespondenceTeam: CorrespondenceTeamDto[] }>()
);

export const addCorrespondenceTeamFailure = createAction(
  '[CorrespondenceTeam] Add CorrespondenceTeam Failure',
  props<{ error: any }>()
);

/**
 * Update CorrespondenceTeam Collection Actions
 */
export const updateCorrespondenceTeam = createAction(
  '[CorrespondenceTeam] Update CorrespondenceTeam',
  props<{ updateCorrespondenceTeam: CorrespondenceTeamDto[] }>()
);

export const updateCorrespondenceTeamSuccess = createAction(
  '[CorrespondenceTeam] Update CorrespondenceTeam Success',
  props<{ updateCorrespondenceTeam: CorrespondenceTeamDto[] }>()
);

export const updateCorrespondenceTeamFailure = createAction(
  '[CorrespondenceTeam] Update CorrespondenceTeam Failure',
  props<{ error: any }>()
);

/**
 * Remove CorrespondenceTeam Collection Actions
 */
export const removeCorrespondenceTeam = createAction(
  '[CorrespondenceTeam] Remove CorrespondenceTeam',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceTeamSuccess = createAction(
  '[CorrespondenceTeam] Remove CorrespondenceTeam Success',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceTeamFailure = createAction(
  '[CorrespondenceTeam] Remove CorrespondenceTeam Failure',
  props<{ error: any }>()
);
